import type { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import type {
    ControlPolicyKind,
    ControlPolicyOption,
} from "./controlPolicyOption";

interface OptionTexts {
    label: string;
    description: string;
    summary: string;
    savedToast: string;
}

export interface ControlPolicyTexts {
    title: string;
    description: string;
    options: Record<ControlPolicyOption, OptionTexts>;
    enforceTitle: string;
    enforceBody: string;
    unlockTitle: string;
    unlockBody: string;
}

export function controlPolicyTexts(
    t: TFunction,
    kind: ControlPolicyKind
): ControlPolicyTexts {
    switch (kind) {
        case "loginProtection":
            return {
                title: t("ControlPolicies_LoginProtection_Title"),
                description: t("ControlPolicies_LoginProtection_Description"),
                options: {
                    off: {
                        label: t("ControlPolicies_LoginProtection_Off"),
                        description: t(
                            "ControlPolicies_LoginProtection_Off_Description"
                        ),
                        summary: t(
                            "ControlPolicies_LoginProtection_Off_Summary"
                        ),
                        savedToast: t(
                            "ControlPolicies_LoginProtection_Off_Saved"
                        ),
                    },
                    on: {
                        label: t("ControlPolicies_LoginProtection_On"),
                        description: t(
                            "ControlPolicies_LoginProtection_On_Description"
                        ),
                        summary: t(
                            "ControlPolicies_LoginProtection_On_Summary"
                        ),
                        savedToast: t(
                            "ControlPolicies_LoginProtection_On_Saved"
                        ),
                    },
                    enforced: {
                        label: t("ControlPolicies_LoginProtection_Enforced"),
                        description: t(
                            "ControlPolicies_LoginProtection_Enforced_Description"
                        ),
                        summary: t(
                            "ControlPolicies_LoginProtection_Enforced_Summary"
                        ),
                        savedToast: t(
                            "ControlPolicies_LoginProtection_Enforced_Saved"
                        ),
                    },
                },
                enforceTitle: t("ControlPolicies_LoginProtection_EnforceTitle"),
                enforceBody: t("ControlPolicies_LoginProtection_EnforceBody"),
                unlockTitle: t("ControlPolicies_LoginProtection_UnlockTitle"),
                unlockBody: t("ControlPolicies_LoginProtection_UnlockBody"),
            };
        case "segregationOfDuties":
            return {
                title: t("ControlPolicies_SegregationOfDuties_Title"),
                description: t(
                    "ControlPolicies_SegregationOfDuties_Description"
                ),
                options: {
                    off: {
                        label: t("ControlPolicies_SegregationOfDuties_Off"),
                        description: t(
                            "ControlPolicies_SegregationOfDuties_Off_Description"
                        ),
                        summary: t(
                            "ControlPolicies_SegregationOfDuties_Off_Summary"
                        ),
                        savedToast: t(
                            "ControlPolicies_SegregationOfDuties_Off_Saved"
                        ),
                    },
                    on: {
                        label: t("ControlPolicies_SegregationOfDuties_On"),
                        description: t(
                            "ControlPolicies_SegregationOfDuties_On_Description"
                        ),
                        summary: t(
                            "ControlPolicies_SegregationOfDuties_On_Summary"
                        ),
                        savedToast: t(
                            "ControlPolicies_SegregationOfDuties_On_Saved"
                        ),
                    },
                    enforced: {
                        label: t(
                            "ControlPolicies_SegregationOfDuties_Enforced"
                        ),
                        description: t(
                            "ControlPolicies_SegregationOfDuties_Enforced_Description"
                        ),
                        summary: t(
                            "ControlPolicies_SegregationOfDuties_Enforced_Summary"
                        ),
                        savedToast: t(
                            "ControlPolicies_SegregationOfDuties_Enforced_Saved"
                        ),
                    },
                },
                enforceTitle: t(
                    "ControlPolicies_SegregationOfDuties_EnforceDialog_Title"
                ),
                enforceBody: t(
                    "ControlPolicies_SegregationOfDuties_EnforceDialog_Body"
                ),
                unlockTitle: t(
                    "ControlPolicies_SegregationOfDuties_UnlockTitle"
                ),
                unlockBody: t("ControlPolicies_SegregationOfDuties_UnlockBody"),
            };
        default:
            return assertNever(kind);
    }
}
